import React, { memo, useRef, useState } from "react";
import { useClickOutside } from "hooks";
import { Input, UncontrolledTooltip } from "reactstrap";
import cx from "classnames";
import { MAX_CUSTOM_PRODUCT_INPUT_LENGTH } from "variables";
import s from "./Styles.module.scss";
import { EditNodeTypes } from "./EditNodeTypes";

export const NodeTitle = memo(
  ({
    title,
    handleUpdateTitle,
    isEditMode,
    setIsEditMode,
    handleToggleEditMode,
    isEditable = true,
    className,
    nodeId,
  }) => {
    const [inputValue, setInputValue] = useState(title || "");
    const inputRef = useRef();
    const tooltipId = `tooltip-${title?.replace(/[^a-zA-Z0-9]/g, "")}${nodeId}`;

    const onUpdateNode = () => {
      if (inputValue !== title) {
        handleUpdateTitle(inputValue);
      }
      setIsEditMode(false);
    };

    const handleInputKeyDown = (e) => {
      if (e.key === "Enter") {
        onUpdateNode();
      }
    };

    useClickOutside(inputRef, () => onUpdateNode(), isEditMode);

    return (
      <div
        className={cx("d-flex flex-column justify-content-center", className)}
        style={{ minWidth: 0 }}
      >
        {isEditMode ? (
          <div
            className={cx(
              s.inputWrapper,
              "d-flex align-items-center border bg-white",
            )}
            ref={inputRef}
          >
            <Input
              className="fw-bolder text-gray-700 ps-2 fs-md border-0"
              type="text"
              bsSize="sm"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              style={{ maxWidth: "calc(100% - 60px)" }}
              maxLength={MAX_CUSTOM_PRODUCT_INPUT_LENGTH}
              onKeyDown={handleInputKeyDown}
              data-testid="folder-title-input"
            />
            <div
              className={cx(
                s.inputLengthLabel,
                "text-gray-400 d-flex flex-nowrap",
              )}
            >
              <span className="fw-bolder">{inputValue.length}</span>
              <span>&nbsp;/ {MAX_CUSTOM_PRODUCT_INPUT_LENGTH}</span>
            </div>
          </div>
        ) : (
          <>
            <span
              id={tooltipId}
              className={cx("fw-bold fs-md text-truncate", s.title, {
                "cursor-pointer": isEditable,
              })}
              onClick={() =>
                isEditable && handleToggleEditMode(EditNodeTypes.TITLE)
              }
              data-testid="folder-title"
            >
              {title}
            </span>
            <UncontrolledTooltip target={tooltipId} placement="top">
              {title}
            </UncontrolledTooltip>
          </>
        )}
      </div>
    );
  },
);
